// Copyright 2025 Imprivata, Inc. All rights reserved.

import { useMutation } from '@tanstack/react-query';
import { clearFactorLockouts, unlockImprIdpUser } from '../../../../api/portalServices';

export type UnlockUserParams = { userId: string; hasAccountLock: boolean; factorTypes: string[] };

export const useUnlockUser = () => {
  return useMutation<void, Error, UnlockUserParams>({
    mutationFn: async ({ userId, hasAccountLock, factorTypes }: UnlockUserParams) => {
      const calls: Promise<void>[] = [];

      if (hasAccountLock) {
        calls.push(unlockImprIdpUser({ userId }));
      }

      if (factorTypes.length > 0) {
        calls.push(clearFactorLockouts({ userId, factorTypes }));
      }

      await Promise.all(calls);
    },
  });
};
